import { atom } from 'jotai';

const uploadProgressAtom = atom({ filename: '', progress: undefined }


);

export { uploadProgressAtom };